export default __webpack_public_path__ + "img/0e0df5ef65e3160fc8523a5e66b187a2.png";